type WindowWithEnv = Window & { env: Record<string, string | undefined> };
const getVariableValue = (variableName: string): string | undefined =>
    import.meta.env.MODE === 'production'
        ? (window as unknown as WindowWithEnv).env?.[variableName]
        : import.meta.env[variableName];

const getBooleanVariableValue = (variableName: string, defaultValue = false): boolean => {
    const value = getVariableValue(variableName);

    if (value === undefined) {
        return defaultValue;
    }

    return value.toLowerCase() === 'true';
};

export const config = {
    env: import.meta.env.MODE || 'development',
    isDev: import.meta.env.MODE !== 'production',
    isBrowser: typeof window !== 'undefined',
    appVersion: String(getVariableValue('VITE_APP_VERSION')),
    apiUrl: getVariableValue('VITE_APP_API_URL'),
    mercureUrl: String(getVariableValue('VITE_APP_MERCURE_HUB_URL')),
    demoEmbeddedAppUrl: String(getVariableValue('VITE_DEMO_EMBEDDED_APP_URL')),
    auth0: {
        audience: String(getVariableValue('VITE_APP_AUTH0_AUDIENCE')),
        domain: String(getVariableValue('VITE_APP_AUTH0_DOMAIN')),
        clientId: String(getVariableValue('VITE_APP_AUTH0_CLIENT_ID')),
        callbackUrl: String(getVariableValue('VITE_APP_AUTH0_CALLBACK_URL')),
        dbConnectionName: String(getVariableValue('VITE_APP_AUTH0_DB_CONNECTION_NAME')),
        resetPasswordUrl: String(getVariableValue('VITE_APP_AUTH0_RESET_PASSWORD_URL')),
    },
    sentry: {
        dsn: getVariableValue('VITE_APP_SENTRY_DSN'),
        release: getVariableValue('VITE_APP_VERSION'),
    },
    productFruits: {
        workspaceCode: getVariableValue('VITE_PRODUCT_FRUITS_WORKSPACE_CODE'),
    },
    googleTagManagerId: 'GTM-P36F96B',
    mrWorkWebsiteBaseUrl: 'https://mrwork.ai',
    jobylonApplicationBaseUrl: getVariableValue('VITE_APP_JOBYLON_APPLICATION_BASE_URL'),
    adBlockerDetector: {
        adSenseUrl: 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js',
        tagManagerUrl: `https://www.googletagmanager.com/gtm.js?gtm_cookies_win=x&id=`,
    },
    linkedIn: {
        clientId: String(getVariableValue('VITE_APP_LINKEDIN_CLIENT_ID')),
    },
    datadogRum: {
        version: getVariableValue('VITE_APP_VERSION'),
        env: getVariableValue('VITE_APP_DATADOG_MONITORING_ENV') || 'development',
        applicationId: 'c4d571b9-7900-4351-8e40-d91612612a24',
        clientToken: 'pub48ef85aceb03d3276c4eafefb6a40956',
    },
    widgetUrl: String(getVariableValue('VITE_WIDGET_URL')),
    zendeskAssetsKey: String(getVariableValue('VITE_ZENDESK_ASSETS_KEY')),
    birdEmailChannelCreationConnectorTemplateRef: 'email-messagebird:1',
    meta: {
        appId: String(getVariableValue('VITE_APP_META_APP_ID')),
        configId: String(getVariableValue('VITE_APP_META_CONFIG_ID')),
        solutionId: String(getVariableValue('VITE_APP_BIRD_SOLUTION_ID')),
    },
};
